import { Switch, useRouteMatch } from 'react-router-dom';
import { CreateReportDialog } from 'assets/js/pages/reports/CreateReportDialog';
import { EditReportDrawer } from 'assets/js/pages/reports/EditReportDrawer';
import { ReportDetail } from 'assets/js/pages/reports/ReportDetail';
import { ReportSchedulesIndex } from 'assets/js/pages/reports/ReportSchedulesIndex';
import { ReportsIndex } from 'assets/js/pages/reports/ReportsIndex';
import { ShareReportDialog } from 'assets/js/pages/reports/ShareReportDialog';
import { useRegisterFilters } from 'assets/js/pages/reports/useRegisterFilters';
import { DialogRoute } from 'components/dialog-route';
import { DialogRouteProps } from 'components/dialog-route/useDialogRouteProps';
import { DrawerRoute } from 'components/drawer-route';
import { ReportingGivebutterPlusSplashPage } from 'components/givebutter-plus-splash/ReportingGivebutterPlusSplashPage';
import { Route } from 'components/router/Route';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const ReportsRouter = () => {
    const match = useRouteMatch();
    const { hasGivebutterPlusAccess } = useCurrentAccount();

    if (!hasGivebutterPlusAccess) {
        return <ReportingGivebutterPlusSplashPage />;
    }

    return (
        <>
            <DialogRoute path={`${match.path}/new`} component={CreateReportDialog} />
            <Switch>
                <Route path={`${match.path}/:report_id(\\d+)`} component={ReportDetailRouter} />
                <Route component={ReportsIndex} path={match.path} />
            </Switch>
        </>
    );
};

const ReportsRouterWrapper = () => {
    const { didInit } = useRegisterFilters();

    if (!didInit) {
        return null;
    }

    return <ReportsRouter />;
};

const ReportDetailRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <DrawerRoute path={`${match.path}/edit`} component={EditReportDrawer} />
            <Switch>
                <Route path={`${match.path}/schedules`} component={ReportSchedulesRouter} />
                <Route path={match.path} component={ReportDetail} />
            </Switch>
        </>
    );
};

const ReportSchedulesRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <ShareReportDialogRoute
                path={[`${match.path}/:schedule_id(\\d+)`, `${match.path}/new`]}
            />
            <Switch>
                <Route path={match.path} component={ReportSchedulesIndex} />
            </Switch>
        </>
    );
};

interface ShareReportDialogRouteProps extends Omit<DialogRouteProps, 'component' | 'variant'> {}
const ShareReportDialogRoute = (props: ShareReportDialogRouteProps) => (
    <DialogRoute
        component={ShareReportDialog}
        contentProps={{ variant: 'fullscreen' }}
        {...props}
    />
);

export { ReportsRouterWrapper as ReportsRouter };
